import { Breadcrumb } from './Breadcrumb';
import { Breadcrumbs as BreadcrumbsRoot } from './Breadcrumbs';

export const Breadcrumbs = Object.assign(BreadcrumbsRoot, {
  Crumb: Breadcrumb,
});
